/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Contact_Code_Tree_CountInputs */

const en_tables_users_contact_code_tree_count = /** @type {(inputs: Tables_Users_Contact_Code_Tree_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

const de_tables_users_contact_code_tree_count = /** @type {(inputs: Tables_Users_Contact_Code_Tree_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Contact Code Trees`)
};

/**
* | output |
* | --- |
* | "Count" |
*
* @param {Tables_Users_Contact_Code_Tree_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_contact_code_tree_count = /** @type {((inputs?: Tables_Users_Contact_Code_Tree_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Contact_Code_Tree_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_contact_code_tree_count(inputs)
	return de_tables_users_contact_code_tree_count(inputs)
});